// 存储当前行的工单列表数据
export default {
  namespaced: true,
  state: {
    rowData: {},//当前行的数据容器
  },
  mutations: {
    changeRowDataWork(state, payload) {
      state.rowData = payload
    }
  }
}